<div class="spinner-container" [class.spinner-inline]="!overlay" *ngIf="showSpinner">
  <div class="spinner">
    <mat-progress-spinner
      class="legacy-like-spinner"
      mode="indeterminate"
      color="primary"
      [strokeWidth]="4"
      [diameter]="spinnerDiameter">
    </mat-progress-spinner>
  </div>
</div>
